import { useQuery } from '@tanstack/react-query';
import { strategyApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

/**
 * Hook to fetch a single strategy by ID
 */
export function useStrategy(id: string) {
  return useQuery({
    queryKey: queryKeys.strategies.detail(id),
    queryFn: () => strategyApi.getStrategy(id),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });
}
